module.exports = __webpack_public_path__ + "static/img/note.58d1a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/note.png
// module id = TfLZ
// module chunks = 0